import { guideLink } from "../utils/nav.js";

// ServiceLad's menu is not here: it has one shared header for React and
// server pages, see src/brands/servicelad/slHeader.js.
// Each brand's menu is deliberately its own ordering and its own subset,
// not one shared list, so the 3 sites don't present an identical templated
// nav to visitors or crawlers. ServiceBoss carries the full set; the other
// two each drop a different pair of secondary items that matter less to
// that brand's own angle (see src/config/brands.js `position`).
const CHECK_A_VEHICLE = { label: "Check a vehicle", href: "/#lookup", primary: true };
const VEHICLE_PAGES = { label: "Tax and MOT check", href: "/vehicle-check" };
// A real URL, not an anchor on the client-rendered homepage, so the nav link
// matches the crawlable /pricing page and works from every route.
const PRICING = { label: "Pricing", href: "/pricing" };
const INSURANCE_GROUP = { label: "Insurance group", href: "/insurance-groups" };
const TAX_CALCULATOR = { label: "Tax calculator", href: "/car-tax-calculator/" };
const ROAD_TAX_CHECK = { label: "Road tax check", href: "/car-tax-calculator/" };
// ServiceBoss has no ULEZ page, so this never joins its list.
const ULEZ_CHECKER = { label: "ULEZ checker", href: "/ulez-checker" };
const V5C_ALERTS = { label: "V5C alerts", href: "/v5c-alerts" };
const FREE_CAR_CHECK = { label: "Free car check", href: "/free-car-check" };
const WHATS_INCLUDED = { label: "What's included", href: "/#features" };
const SAMPLE_REPORT = { label: "Sample report", href: "/#sample" };
const ABOUT = { label: "About", href: "/about" };
const CONTACT = { label: "Contact", href: "/contact" };
const TERMS = { label: "Terms", href: "/terms" };
const PRIVACY = { label: "Privacy", href: "/privacy" };

// position: manufacturer-service-history. Full menu, nothing dropped.
const serviceBossLinks = [CHECK_A_VEHICLE, PRICING, INSURANCE_GROUP, TAX_CALCULATOR, FREE_CAR_CHECK, V5C_ALERTS, WHATS_INCLUDED, SAMPLE_REPORT, ABOUT, CONTACT, TERMS, PRIVACY];

// position: vehicle-risk-checks. Drops Sample report and V5C alerts, this
// brand's own product is the risk check itself, not ongoing monitoring.
const serviceByRegLinks = [CHECK_A_VEHICLE, VEHICLE_PAGES, PRICING, INSURANCE_GROUP, V5C_ALERTS, ROAD_TAX_CHECK, ULEZ_CHECKER, FREE_CAR_CHECK, ABOUT, CONTACT, TERMS, PRIVACY];

const linksByBrand = {
  serviceboss: serviceBossLinks,
  servicebyreg: serviceByRegLinks,
};

// The brand's burger menu: its own list, with Guides right after "Free car check".
export function navLinksForBrand(brand) {
  const baseLinks = linksByBrand[brand.key] || serviceBossLinks;
  const freeCarCheckIndex = baseLinks.findIndex((link) => link.href === "/free-car-check");
  return freeCarCheckIndex === -1
    ? [...baseLinks, ...guideLink(brand)]
    : [...baseLinks.slice(0, freeCarCheckIndex + 1), ...guideLink(brand), ...baseLinks.slice(freeCarCheckIndex + 1)];
}
